import AnimatedCard from '../components/AnimatedCard';
import SectionHeader from '../components/SectionHeader';
import Seo from '../seo/Seo';
import { TESTIMONIALS_SEO } from '../seo/pageSeo';

const TESTIMONIALS = [
  { name:'Amit Sharma',  company:'Sharma Pvt. Ltd.',     text:'VTCodex delivered our school portal in record time. The design is stunning and our students absolutely love it!', rating:5 },
  { name:'Priya Verma',  company:'Digital Verse Agency', text:'The team is incredibly responsive and professional. Our e-commerce site saw a 200% traffic boost after their SEO work.', rating:5 },
  { name:'Rohit Gupta',  company:'GuptaTech Solutions',  text:'Affordable, fast, and high quality. VTCodex built our entire digital infrastructure. Truly a one-stop digital shop.', rating:5 },
  { name:'Sunita Patel', company:'Patel Institutes',     text:'Our college website went from outdated to world-class. The team understood our requirements perfectly.', rating:4 },
  { name:'Vikram Singh', company:'Singh Enterprises',    text:'Payment gateway integration was seamless. The backend team is top-notch and extremely knowledgeable.', rating:5 },
  { name:'Kavya Reddy',  company:'Reddy Foods',          text:'Amazing work on our restaurant booking app! Customers love the smooth UI and instant booking confirmation.', rating:5 },
];

export default function TestimonialsPage() {
  return (
    <>
      <Seo {...TESTIMONIALS_SEO} />
    <section className="py-20 px-8 bg-[#050810]" aria-label="Client testimonials">
      <div className="max-w-7xl mx-auto">
        <SectionHeader label="CLIENT LOVE" title="Testimonials" sub="What our clients say about working with us" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <AnimatedCard key={t.name} delay={i * 0.1}
              className="relative overflow-hidden rounded-2xl p-7 cursor-none border border-[rgba(139,92,246,.1)] bg-[rgba(10,15,30,.9)] transition-all duration-[.4s]
                hover:-translate-y-1.5 hover:border-[rgba(139,92,246,.3)] hover:shadow-[0_20px_40px_rgba(0,0,0,.5),0_0_22px_rgba(139,92,246,.1)]">

              {/* decorative quote */}
              <div className="absolute -top-3 right-4 text-[8rem] leading-none pointer-events-none select-none font-cursive"
                style={{ color:'rgba(0,245,255,.04)' }}>"</div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[1,2,3,4,5].map(s => (
                  <span key={s} className={`text-lg ${s <= t.rating ? 'text-[#00f5ff]' : 'text-slate-700'}`}>★</span>
                ))}
              </div>

              <p className="text-slate-400 text-sm leading-relaxed italic mb-6">"{t.text}"</p>

              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 font-cursive font-bold text-lg text-black"
                  style={{ background:'linear-gradient(135deg,#00f5ff,#8b5cf6)' }}>
                  {t.name[0]}
                </div>
                <div>
                  <p className="font-cursive font-bold text-slate-100 text-base">{t.name}</p>
                  <p className="font-mono text-xs text-slate-500">{t.company}</p>
                </div>
              </div>
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
    </>
  );
}
